import React, { useState, useEffect } from "react";
import { getSettings, updateSettings } from "../api/authApi";
import view from "../components/images/view.png";
import hide from "../components/images/hide.png";
import ChangePassword from "../components/ChangePassword";

export default function SettingsPage() {
	const [form, setForm] = useState({
		app_name: "",
		contact_email: "",
		stripe_secret: "",
		stripe_publishable: "",
	});
	const [loading, setLoading] = useState(true);
	const [showSecret, setShowSecret] = useState(false);

	useEffect(() => {
		getSettings()
			.then((res) => {
				if (res.data)
					setForm(res.data);
				setLoading(false);
			})
			.catch(() => setLoading(false));
	}, []);

	const handleChange = (e) => setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

	const handleSubmit = async (e) => {
		e.preventDefault();
		await updateSettings(form);
		alert("Settings saved!");
	};

	if (loading) return <div>Loading…</div>;

	return (
		<div className="max-w-xl mx-auto bg-white border rounded-2xl shadow p-8 space-y-8">
			<form onSubmit={handleSubmit} className="space-y-4" autoComplete="off">
				<h2 className="text-xl font-bold text-gray-900 mb-4">Settings</h2>
				<div className="space-y-4">
					<div>
						<label className="block text-sm font-medium text-gray-700 mb-1">App Name</label>
						<input
							type="text"
							name="app_name"
							value={form.app_name || ""}
							onChange={handleChange}
							className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring"
							placeholder="Your App Name"
						/>
					</div>
					<div>
						<label className="block text-sm font-medium text-gray-700 mb-1">Contact Email</label>
						<input
							type="email"
							name="contact_email"
							value={form.contact_email || ""}
							onChange={handleChange}
							className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring"
							placeholder="contact@company.com"
						/>
					</div>
					<div>
						<label className="block text-sm font-medium text-gray-700 mb-1">Stripe Secret Key</label>
						<div className="flex gap-2">
							<input
								className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring"
								type={showSecret ? "text" : "password"}
								name="stripe_secret"
								value={form.stripe_secret || ""}
								onChange={handleChange}
								placeholder="sk_live_..."
								autoComplete="new-password"
							/>
							<span className="flex justify-around items-center" onClick={() => setShowSecret((v) => !v)}>
								<img src={showSecret ? view : hide} alt={showSecret ? "Hide secret" : "Show secret"} className="h-5 w-5" />
							</span>
						</div>
					</div>
					<div>
						<label className="block text-sm font-medium text-gray-700 mb-1">Stripe Publishable Key</label>
						<input
							type="text"
							name="stripe_publishable"
							value={form.stripe_publishable || ""}
							onChange={handleChange}
							className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring"
							placeholder="pk_live_..."
							autoComplete="new-password"
						/>
					</div>
					{form.stripe_webhook_url && (
						<div>
							<label className="block text-sm font-medium text-gray-700 mb-1">Stripe Webhook URL</label>
							<input
								type="text"
								name="stripe_webhook_url"
								value={form.stripe_webhook_url}
								readOnly
								className="w-full px-3 py-2 border rounded-lg bg-gray-100 text-gray-600"
							/>
						</div>
					)}
				</div>
				<button type="submit" className="px-6 py-2 rounded-xl bg-black text-white font-semibold shadow hover:bg-gray-900 transition">
					Save Settings
				</button>
			</form>
			<ChangePassword />
		</div>
	);
}
